import React from 'react';
import { Styling } from './styled.js'
export default function WishlistNotification(
) {
  return    <Styling>
                <div className="wishlist-notification">You have added a product to your wishlist</div>
            </Styling>
}
